"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeAssertFunction = exports.assertFunction = exports.FunctionAssertionError = void 0;
var assert_1 = require("./assert");
var tuple_1 = require("../types/tuple");
var FunctionAssertionError = /** @class */ (function (_super) {
    __extends(FunctionAssertionError, _super);
    function FunctionAssertionError(functionName, argsLength, invalidations) {
        var _this = _super.call(this, invalidations) || this;
        var args = __spread(Array(argsLength).keys()).map(function (index) { return "arg" + index; }).join(', ');
        var prefix = functionName.length === 0 ? "function (" + args + ") - args" : "function " + functionName + "(" + args + ") - args";
        _this.message = "" + prefix + _this.message;
        _this.functionName = functionName;
        return _this;
    }
    return FunctionAssertionError;
}(assert_1.AssertionError));
exports.FunctionAssertionError = FunctionAssertionError;
/**
 * Assert a functions arguments using type-guards
 * @param argumentsGuards guards for arguments
 * @param func the function that arguments are passed to
 * @param name override function name
 */
function assertFunction(argumentsGuards, func, name) {
    var _a;
    var guard = tuple_1.tuple(argumentsGuards);
    var functionName = name !== null && name !== void 0 ? name : func.name;
    var assertedFunc = (_a = {},
        _a[functionName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var coercedArguments = guard.coerce(args);
            assert_1.assert(guard, coercedArguments, function (invalidation) {
                return new FunctionAssertionError(functionName, argumentsGuards.length, invalidation);
            });
            return func.apply(void 0, __spread(coercedArguments));
        },
        _a)[functionName];
    return assertedFunc;
}
exports.assertFunction = assertFunction;
/**
 * Fake assert a functions arguments using type-guards to get correct types
 * @param argumentsGuards guards for arguments
 * @param func the function that arguments are passed to
 * @param name override function name
 */
function fakeAssertFunction(argumentsGuards, func, name) {
    var _a;
    if (name === undefined) {
        return func;
    }
    else {
        return (_a = {}, _a[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return func.apply(void 0, __spread(args));
        }, _a)[name];
    }
}
exports.fakeAssertFunction = fakeAssertFunction;
